import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Row} from 'react-bootstrap';

import SectionHeader from 'components/SectionHeader';
import CourseItem from 'components/CourseItem';
import PageSection from 'components/PageSection';
import FareHaborItemLink from 'components/FareHaborItemLink';
import nl2br from 'utils/nl2br';
import './Courses.scss';

const Courses = ({className, frontmatter, globals, location}) => {
    if (!frontmatter) {
        return null;
    }

    const {
        anchor,
        anchorText,
        header: rootHeader,
        subheader: rootSubHeader,
        courses,

        coursesBeginnerHeader,
        coursesBeginnerSubheader,
        coursesBeginner,

        coursesAdvancedHeader,
        coursesAdvancedSubheader,
        coursesAdvanced,

        coursesKnowledgeHeader,
        coursesKnowledgeSubheader,
        coursesKnowledge,

        coursesProfessionalHeader,
        coursesProfessionalSubheader,
        coursesProfessional,

        coursesSnorkelingHeader,
        coursesSnorkelingSubheader,
        coursesSnorkeling,

        coursesOthersHeader,
        coursesOthersSubheader,
        coursesOthers
    } = frontmatter;

    const courseListing = [];

    if (coursesBeginner && coursesBeginner.length > 0) {
        courseListing.push({
            header: coursesBeginnerHeader,
            subheader: coursesBeginnerSubheader,
            c: coursesBeginner
        });
    }

    if (coursesAdvanced && coursesAdvanced.length > 0) {
        courseListing.push({
            header: coursesAdvancedHeader,
            subheader: coursesAdvancedSubheader,
            c: coursesAdvanced
        });
    }

    if (coursesKnowledge && coursesKnowledge.length > 0) {
        courseListing.push({
            header: coursesKnowledgeHeader,
            subheader: coursesKnowledgeSubheader,
            c: coursesKnowledge
        });
    }

    if (coursesProfessional && coursesProfessional.length > 0) {
        courseListing.push({
            header: coursesProfessionalHeader,
            subheader: coursesProfessionalSubheader,
            c: coursesProfessional
        });
    }

    if (coursesSnorkeling && coursesSnorkeling.length > 0) {
        courseListing.push({
            header: coursesSnorkelingHeader,
            subheader: coursesSnorkelingSubheader,
            c: coursesSnorkeling
        });
    }

    if (coursesOthers && coursesOthers.length > 0) {
        courseListing.push({
            header: coursesOthersHeader,
            subheader: coursesOthersSubheader,
            c: coursesOthers
        });
    }

    if (courses && courses.length > 0) {
        courseListing.push({
            header: rootHeader,
            subheader: rootSubHeader,
            c: courses
        });
    }

    return (
        <PageSection className={clsx('course-section', className)} id={anchor}>
            {courseListing.map((listing) => {
                return (
                    <Fragment key={listing.header}>
                        <Row>
                            <SectionHeader header={listing.header} subheader={listing.subheader}/>
                        </Row>
                        <Row className="mb-lg-5">
                            {listing.c.map(
                                ({content, courseData, header, imageFileName, imageFileNameDetail, subheader}) => {
                                    return (
                                        <CourseItem
                                            key={header}
                                            imageFileName={imageFileName}
                                            header={header}
                                            subheader={subheader}
                                            content={content}
                                            globals={globals}
                                            location={location}
                                            imageFileNameDetail={imageFileNameDetail}
                                            courseData={courseData && courseData.length ? (
                                                <table className="table table-hover">
                                                    <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">{anchorText}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {courseData.map((c) => {
                                                        return (
                                                            <tr key={c.title}>
                                                                <td>
                                                                    <div className="course-container">
                                                                        <div className="course-description">
                                                                            <h5 style={{color: 'var(--primary)'}}>{c.title}</h5>
                                                                            <p dangerouslySetInnerHTML={{__html: nl2br(c.description)}}/>
                                                                            {(c.courseMinimumAge || c.coursePrerequisites || c.courseAcademicSessions || c.coursePoolSessions || c.courseDives) && <b>{globals.courseBullets}</b>}
                                                                            {c.courseMinimumAge && <dl>
                                                                                <dt>{globals.courseMinimumAge}</dt>
                                                                                <dd>{c.courseMinimumAge}</dd>
                                                                            </dl>}
                                                                            {c.coursePrerequisites && <dl>
                                                                                <dt>{globals.coursePrerequisites}</dt>
                                                                                <dd>{c.coursePrerequisites}</dd>
                                                                            </dl>}
                                                                            {c.courseAcademicSessions && <dl>
                                                                                <dt>{globals.courseAcademicSessions}</dt>
                                                                                <dd>{c.courseAcademicSessions}</dd>
                                                                            </dl>}
                                                                            {c.coursePoolSessions && <dl>
                                                                                <dt>{globals.coursePoolSessions}</dt>
                                                                                <dd>{c.coursePoolSessions}</dd>
                                                                            </dl>}
                                                                            {c.courseDives && <dl>
                                                                                <dt>{globals.courseDives}</dt>
                                                                                <dd>{c.courseDives}</dd>
                                                                            </dl>}
                                                                        </div>
                                                                        <div className="course-pricing">
                                                                            {c.price &&
                                                                                <h2 style={{whiteSpace: 'nowrap'}}>{c.price}</h2>}
                                                                            {c.fareHabor &&
                                                                                <FareHaborItemLink
                                                                                    itemId={c.fareHabor}/>}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            ) : null}
                                        />
                                    );
                                }
                            )}
                        </Row>
                    </Fragment>
                );
            })}
        </PageSection>
    );
};

Courses.propTypes = {
    className: PropTypes.string,
    frontmatter: PropTypes.object,
    globals: PropTypes.object,
    location: PropTypes.object,
};

Courses.defaultProps = {
    className: null,
    frontmatter: null,
    globals: null,
    location: null,
};

export default Courses;
